define('formkit/view/form.object/content/radio.content.view',['require','exports','module','underscore','uikit/uikit','../../../templates','./base.selectable.content.view','../../../behavior/single.answer.value.behavior'],function(require, exports, module) {
  //prettier-ignore
  var _                         = require('underscore'),
      UIKit                     = require('uikit/uikit'),
      Templates                 = require('../../../templates'),
      BaseSelectableContentView = require('./base.selectable.content.view'),
      SingleAnswerValueBehavior = require('../../../behavior/single.answer.value.behavior');

  var DesignAnswerView = BaseSelectableContentView.DesignAnswerView.extend({
    template: Templates.App['radio.object.design'],
  });

  var PreviewAnswerView = BaseSelectableContentView.PreviewAnswerView.extend({
    template: Templates.App['radio.object.preview'],
    internalViewOptions: BaseSelectableContentView.PreviewAnswerView.extendInternalViewOptions({
      groupView: function() {
        var self = this;
        return {
          type: UIKit.CheckboxGroup.extend({
            onAddChild: function(view) {
              view.on('change:value', function(checkboxView, value, previous, options) {
                view.answerValueModel.set('value', !!view.value, {
                  isFromServer: _.result(options, 'isFromServer'),
                });
                if (!_.result(options, 'isFromServer')) {
                  this.form.triggerBeginEditAnswerEvent(view, view.model, {
                    answerValueModel: self.getAndLinkAnswerValueModel(view.model, self.form),
                  });
                  this.form.triggerEndEditAnswerEvent(view, view.model, {
                    answerValueModel: self.getAndLinkAnswerValueModel(view.model, self.form),
                  });
                }
              });

              view.listenTo(view.answerValueModel, 'change:value', function(model, value, options) {
                view._setOption('value', !!view.answerValueModel.get('value'), {
                  isFromServer: _.result(options, 'isFromServer'),
                });
              });
            },

            onChangeReadonly: function() {
              this.children.each(function(childView) {
                childView.readonly = this.readonly;
              }, this);
            },
          }),
          radio: true,

          childViewOptions: function(model) {
            var answerValueModel = self.getAndLinkAnswerValueModel(model, self.form);
            if (answerValueModel.get('value') == null) {
              answerValueModel.set('value', false);
            }
            return _.extend({}, UIKit.CheckboxGroup.prototype.childViewOptions.apply(this, arguments), {
              form: this.form,
              model: model,
              answerValueModel: answerValueModel,
              answerModel: this.form.getAnswerModel(model),
              value: !!answerValueModel.get('value'),
              readonly: this.getOption('readonly'),
              comparing: this.getOption('comparing'),
            });
          },
          childView: UIKit.Checkbox.extend({
            attributes: function() {
              return {
                'data-id': this.model ? this.model.id : null,
              };
            },

            behaviors: {
              SingleAnswerValueBehavior: {
                resetValue: false,
                isMultiAnswerValue: self.getOption('isMultiAnswerValue'),
                answerValueIndex: self.getAnswerValueIndex(),
                behaviorClass: SingleAnswerValueBehavior,
              },
            },

            updateAttributes: function() {
              UIKit.Checkbox.prototype.updateAttributes.apply(this);

              if (this.getOption('comparing') && this.form.util.isChanged(this.model)) {
                this.addClass('changed', true);
              } else if (this.getOption('comparing') && this.form.util.isMovedChanged(this.model)) {
                this.addClass('moved-changed', true);
              }
            },
          }),
        };
      },
    }),
  });

  var RadioContentView = BaseSelectableContentView.extend({
    internalViewOptions: BaseSelectableContentView.extendInternalViewOptions({
      designAnswerView: function() {
        return {
          type: DesignAnswerView,
        };
      },
      previewAnswerView: function() {
        return {
          type: PreviewAnswerView,
        };
      },
    }),

    // ignore changed status on radio button
    updateChangedStatusAttributes: function() {},
  });

  RadioContentView.PreviewAnswerView = PreviewAnswerView;
  RadioContentView.DesignAnswerView = DesignAnswerView;

  module.exports = RadioContentView;
});

